import './style.scss'
import { useTranslation } from 'react-i18next';
import LanguageSelector from '../LanguageSelector/LanguageSelector';

const AvisoLegal = () => {
	const{t}=useTranslation();
	return(
		<div className="table-container table-manual">
			<div className="table">
			<div>
				<div style={{ position: "relative" }}>
					<div data-automation-id="visibleContent">
						<div className="ms-FocusZone ms-CommandBar manual-CommandBar" role="menubar" data-focuszone-id="FocusZone9">
							<div role="none" className="ms-OverflowSet ms-CommandBar-primaryCommand">
								<div className="ms-OverflowSet-item">
									<div role="menuitem" className="ms-Button ms-Button--commandBar ms-CommandBarItem-link" data-is-focusable="true">
										<span className="ms-Button-flexContainer flexContainer-60" data-automationid="splitbuttonprimary">
											<span className="ms-Button-textContainer textContainer-61">
												<span className="ms-Button-label" id="id__10">{t('Toaccess')}
													
												</span>
											</span>
										</span>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
				<div className="container">
						<div className="">
						<p>{t('Disclaimer')}</p>
						</div>
					
				</div>
			</div>
		</div>
	)
}

export default AvisoLegal;
